'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Join = ({ children, joiner }) => (React__default.default.createElement(React__default.default.Fragment, null, React.Children.toArray(children)
    .filter(Boolean)
    .map((child, index) => (React__default.default.createElement(React.Fragment, { key: index },
    index > 0 && joiner,
    child)))));

exports.Join = Join;
//# sourceMappingURL=component.js.map
